import { Link } from "react-router-dom";
import DataTable from "../table/DataTable";
import StatusBadge from "../table/StatusBadge";
import TablePaginationFooter from "../table/TablePaginationFooter";
import {
  formatPushDateTime,
  getPushStatusLabel,
  getPushStatusVariant,
} from "../../helpers/push-notifications";

function PushNotificationHistoryTable({ response, loading, onPage }) {
  const rows = response?.data ?? [];
  const metadata = response?.metadata ?? {};
  const columns = [
    {
      key: "notification",
      label: "Notification",
      render: (job) => (
        <div>
          <Link
            to={`/push-notifications/history/${job.id}`}
            className="font-semibold text-primary hover:underline"
          >
            {job.title}
          </Link>
          <div className="mt-1 text-xs text-slate-500">Job #{job.id}</div>
        </div>
      ),
    },
    { key: "category", label: "Category" },
    {
      key: "audience",
      label: "Audience",
      render: (job) => job.audienceType ?? job.audience?.type ?? "—",
    },
    {
      key: "status",
      label: "Status",
      render: (job) => (
        <StatusBadge
          label={getPushStatusLabel(job.status, job.totalRecipients)}
          variant={getPushStatusVariant(job.status)}
        />
      ),
    },
    {
      key: "createdOn",
      label: "Created",
      render: (job) => formatPushDateTime(job.createdOn),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={rows}
      rowKey="id"
      loading={loading}
      minWidth="900px"
      emptyMessage="No notification jobs match these filters."
      footer={
        <TablePaginationFooter
          currentPage={metadata.currentPage ?? 0}
          totalPages={metadata.totalPages ?? 0}
          pageSize={metadata.pageSize ?? 20}
          totalItems={metadata.totalItems ?? metadata.totalElements ?? metadata.totalCount}
          currentItemCount={rows.length}
          onPage={onPage}
        />
      }
    />
  );
}

export default PushNotificationHistoryTable;
